export const BatteryType = {
  Condenser: "Condenser",
  Evaporator: "Evaporator",
};
